import { NgModule } from '@angular/core';
import { BrandCasePipe } from './brandcase.pipe';
import { CapitalCasePipe } from './capitalcase.pipe';
import { TimeFormatPipe } from './timeFormat.pipe';

@NgModule({
  declarations: [BrandCasePipe, TimeFormatPipe, CapitalCasePipe],
  exports: [TimeFormatPipe, BrandCasePipe, CapitalCasePipe],
  providers: [BrandCasePipe, TimeFormatPipe, CapitalCasePipe],
})
export class PlanDetailsPipeModule {}
